import * as React from 'react';
import '../css/featured-section-card.sass';
import Anchor from './Anchor';
import Card from './Card';

interface FeaturedSectionCardProps {
  imageUrl?: string;
  title?: string;
  releaseYear?: string;
  genre?: string;
  duration?: string;
  ratings?: string;
  otherInfo?: string;
  movieDetailsUrl?: string;
  is18Plus?: boolean;
  message?: React.ReactNode;
  movieDetailsUrlLbl?: string;
  is18PlusLbl?: string;
  additionalContainerClasses?: string;
}

export default function FeaturedSectionCard(props: FeaturedSectionCardProps) {
  const { movieDetailsUrlLbl = 'Movie Details', is18PlusLbl = '18+' } = props;
  return (
    <div className={`featured-card ${props.additionalContainerClasses || ''}`}>
      <Card>
        <div className="featured-card-content">
          {!props.is18Plus && (
            <img
              src={props.imageUrl}
              alt={props.title}
              className="featured-card-poster"
            />
          )}
          {!!props.is18Plus && (
            <>
              <img
                src="18plusContent"
                alt="18 plus content"
                className="featured-card-poster adult"
              />
              <div className="top-right-adult">{is18PlusLbl}</div>
            </>
          )}
          {!props.message && (
            <div
              className={`featured-card-details${
                props.additionalContainerClasses?.includes(
                  'unset-card-position'
                )
                  ? ' ml-4'
                  : ''
              }`}
            >
              <h1 className="title mb-2">{props.title}</h1>
              <div className="featured-card-info mb-2">
                {props.releaseYear}
                {props.releaseYear && !props.genre && props.duration && (
                  <span className="featured-card-dot" />
                )}
                {props.releaseYear && props.genre && (
                  <span className="featured-card-dot" />
                )}
                {props.genre}
                {props.genre && props.duration && (
                  <span className="featured-card-dot" />
                )}
                {props.duration}
              </div>
              {props.ratings && (
                <div className="featured-card-content mb-3">
                  <div className="type">{props.ratings}</div>
                </div>
              )}
              <div className="featured-card-info">{props.otherInfo}</div>
              {props.movieDetailsUrl && (
                <div className="featured-card-link">
                  <Anchor
                    href={props.movieDetailsUrl}
                    id="movieDetails"
                    arialabel="Movie Details"
                    forward
                  >
                    {movieDetailsUrlLbl}
                  </Anchor>
                </div>
              )}
            </div>
          )}
          {props.message && (
            <div className="featured-card-message">{props.message}</div>
          )}
        </div>
      </Card>
    </div>
  );
}
